export const ID27 = ()=> {
    return(
        <div>
            <div className="content" readonly=""><h1>1С:Производственная безопасность. Комплексная</h1>

                <img src="https://cybernetica.kz/uploads/gallery/403749709.png" alt=""/>

                <h2>Охрана труда</h2>
                <ul>
                    <li>Планирование, ввод и хранение результатов проведения специальной оценки условий труда (СОУТ)
                    </li>
                    <li>Планирование и контроль прохождения сотрудниками медицинских осмотров</li>
                    <li>Планирование и контроль учебной деятельности сотрудников в области охраны труда (обучения,
                        инструктажей, стажировок, проверки знаний)
                    </li>
                    <li>Учет и контроль обеспеченности средствами индивидуальной защиты (СИЗ), смывающими и
                        обезвреживающими средствами (СиОС)
                    </li>
                    <li>Работа с данными о несчастных случаях на производстве</li>
                    <li>Учет выданных нарядов и нарядов-допусков; формирование соответствующей документации</li>
                    <li>Планирование и контроль сроков выполнения мероприятий</li>
                    <li>Осуществление производственного контроля за соблюдением санитарных правил на предприятии</li>
                    <li>Планирование и учет результатов проведения проверок</li>
                    <li>Формирование регламентированной и аналитической документации</li>
                    <li>Работа с нормативно-техническими документами в области охраны труда</li>
                    <li>Учет данных о предприятии</li>
                </ul>

                <h2>Охрана окружающей среды</h2>
                <ul>
                    <li>Ведение учета количества источников выброса, с учетом мест замера загрязняющих веществ</li>
                    <li>Ведение учета газопылеулавливающих установок; учета промышленных площадок по направлениям: вода,
                        воздух, отходы
                    </li>
                    <li>Учет критериев отнесения объектов, оказывающих негативное воздействие на окружающую среду, к
                        объектам I-IV категориям.
                    </li>
                    <li>Учет выбросов в разрезе ОКТМО региона</li>
                    <li>Формирование отчета и пояснительной записки по количественному определению объема парниковых
                        газов
                    </li>
                    <li>Ведение учета выбросов по нескольким промышленным площадкам</li>
                    <li>Формирование классификатора бюджетных организаций</li>
                    <li>Формирование авансовых платежей по периодам</li>
                    <li>Расчет платы за негативное воздействие с указанием коэффициентов и ставок платы по направлениям
                        вода, воздух, отходы
                    </li>
                    <li>
                        Формирование декларации о плате за негативное воздействие на окружающую среду, аналитических
                        отчетов по фактическому выбросу загрязняющих веществ,
                        превышению нормативов, отчетов 2-ТП (воздух), отчетов 4-ОС
                    </li>
                    <li>Учет объектов водопотребления и водоотведения</li>
                    <li>Учет выпусков сточных вод</li>
                    <li>
                        Формирование точек водозабора с указанием координат, характеристик объектов
                        водопользования,&nbsp; аналитического отчета по фактическому сбросу
                        загрязняющих веществ, справочника бассейнов морей и рек
                    </li>
                    <li>Актуализация справочника федерального классификационного каталога отходов</li>
                    <li>Учет мест накопления/объектов размещения отходов</li>
                    <li>Ввод сведений по отходам в разрезе промышленных площадок</li>
                    <li>Формирование технического отчета по обращению с отходами</li>
                    <li>Учет лимитов на размещения отходов и лицензий на осуществление деятельности по сбору,
                        транспортированию, обезвреживанию и размещению отходов
                    </li>
                    <li>
                        Возможность просмотра сведений о лимитах размещения, остатке лимита по выбранному отходу в
                        поступлении, передаче, переводе отходов из накопления в
                        хранение
                    </li>
                </ul>

                <h2>Промышленная безопасность</h2>

                <ul>
                    <li>Ведение учета опасных производственных объектов (ОПО), технических устройств, применяемых на
                        ОПО.
                    </li>
                    <li>Учет гидротехнических сооружений</li>
                    <li>Контроль своевременности проведения регламентных работ по промышленной безопасности</li>
                    <li>Планирование и учет результатов проведения учебных тревог и занятий</li>
                    <li>Формирование регламентированной и различной не регламентированной отчетности</li>
                    <li>Учет результатов расследований аварий и происшествий на ОПО</li>
                    <li>
                        Формирование отчета по Приказу Федеральной службы по экологическому, технологическому и атомному
                        надзору от 23 января 2014 г. N 25 "Об утверждении
                        Требований к форме представления организацией, эксплуатирующей опасный производственный объект,
                        сведений об организации производственного контроля за
                        соблюдением требований промышленной безопасности в Федеральную службу по экологическому,
                        технологическому и атомному надзору"
                    </li>
                    <li>Планирование проведения производственного контроля и учет его результатов</li>
                    <li>Планирование и учет результатов проведения проверок</li>
                    <li>Планирование и контроль учебной деятельности сотрудников в области промышленной безопасности
                        (обучения, инструктажей, стажировок, проверки знаний)
                    </li>
                </ul>

                <h2>Пожарная безопасность</h2>
                <ul>
                    <li>
                        Ведение учета объектов противопожарной защиты, пожарного оборудования и средств (первичные и
                        мобильные средства пожаротушения, средства огнезащиты и
                        пожарной автоматики и т.д)
                    </li>
                    <li>
                        Регистрация сведений о договорах с пожарной охраной, ведение учета подразделений пожарной охраны
                        (ведомственных, государственных, добровольных,
                        муниципальных, частных), привлекаемых организацией для ликвидации пожаров и их последствий
                    </li>
                    <li>Планирование и регистрация результатов противопожарных тренировок, проведенных в организации
                    </li>
                    <li>
                        Планирование и учет результатов проводимых регламентных работ для пожарного оборудования,
                        средств огнезащиты и пожаротушения, включающих техническое
                        освидетельствование, осмотр, проверку работоспособности, комплексные испытания, обслуживание
                        пожарного оборудования и др
                    </li>
                    <li>Учет состава участников пожарно-технической комиссии</li>
                    <li>Учет результатов расследования пожаров</li>
                    <li>Формирование регламентированной документации, а также отчетных и аналитических форм</li>
                    <li>Планирование и учет результатов проведения проверок объектов защиты на соответствие требованиям
                        пожарной безопасности
                    </li>
                    <li>Планирование и контроль учебной деятельности сотрудников в области пожарной безопасности
                        (обучения, инструктажей, стажировок, проверки знаний)
                    </li>
                </ul>

                <h2>Обучение и проверка знаний</h2>
                <ul>
                    <li>Список профессий и должностей, подлежащих обучению и инструктажам</li>
                    <li>График проведения инструктажей</li>
                    <li>Результат проведения инструктажей</li>
                    <li>График проведения обучения и аттестации сотрудников</li>
                    <li>График проверки знаний на допуск</li>
                    <li>Допуски к работам</li>
                </ul>

                <h2>Наряды-допуски</h2>
                <p>Раздел "Наряды-допуски" предназначен для ведения учета допусков сотрудников к работам повышенной
                    опасности:</p>
                <ul type="disc">
                    <li>выданные наряды;</li>
                    <li>наряды-допуски на выполнение работ повышенной опасности;</li>
                    <li>&nbsp;наряды-допуски в электроэнергетике.</li>
                </ul>

                <h2>Проверки</h2>
                <p>
                    Проведение внутренних проверок на предприятии позволяет получить объективную информацию о выполнении
                    установленных требований. В системе реализована
                    возможность формирования планов проверок, учета их результатов, а также планирования мероприятий для
                    устранения выявленных нарушений.
                </p>

                <h2>Совместная работа. Планирование и контроль сроков выполнения мероприятий</h2>
                <p>
                    Система предоставляет возможность планирования и контроля выполнения мероприятий по устранению
                    нарушений требований нормативно-технической документации,
                    выявленных в результате расследования несчастных случаев и профзаболеваний, внешних и внутренних
                    проверок состояния охраны труда, охраны окружающей среды,
                    промышленной и пожарной безопасности, а также мероприятий, направленных на предупреждение
                    аналогичных несчастных случаев и профзаболеваний в будущем. В
                    системе реализованы аналитические отчеты для оперативного получения информации о выполнении
                    мероприятий в различных разрезах.
                </p>

                <h2>Нормативно-справочная информация</h2>
                <p>
                    В системе ведется учет сведений о нормативно-технической документации, а также ее требований.
                    Документация может быть как внутренней (внутренние положения
                    предприятия), так и федеральные законы, постановления и т.п. При формировании перечня нарушений в
                    системе, предоставляется возможность указания пункта
                    нарушенного требования.
                </p>

                <h2>Предприятие. Учет сведений о предприятии и о сотрудниках</h2>
                <p>В системе ведется учет сведений об организационной структуре предприятия, а также сведений о
                    сотрудниках</p></div>
        </div>
    )
}